<template>
  <div class="snsBox">
    <a href="#" v-for="sns in snsList" :key="sns.id" @click.prevent><img :src="require(`@/assets/img/sns_${sns.id}.png`)" :alt="sns.label"></a>
    <button type="button" class="btnSetSns" @click="onSnsMode"><img src="~@/assets/img/ico_setting.svg" alt=""></button>
  </div>
</template>

<script>
export default {
  name: 'MenuSns',
  props: [
    'sns'
  ],
  computed: {
    snsList () {
      return this.sns.filter(x => x.active)
    }
  },
  methods: {
    onSnsMode () {
      this.$emit('setMode', 'sns')
    }
  }
}
</script>

<style lang="scss" scoped>
.snsBox {
  display: flex;
  position: relative;
  padding: 30px;
  justify-content: center;
  border: 1px solid $color-lgrey2;
  a {
    margin: 0 10px;
    img {
      width: 30px;
    }
  }
  .btnSetSns {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    img {
      width: 24px;
    }
  }
}
</style>
